import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { FieldModal, FieldSelectionModal } from '../../../modals';
import { FormBuilderService } from '../../../services';

@Component({
	selector: 'app-document-template-new',
	templateUrl: './document-template-new.component.html',
	styleUrls: [ './document-template-new.component.scss' ]
})
export class DocumentTemplateNewComponent implements OnInit {
	pending: boolean;
	success: any;
	error: any;
	fieldArrays: Array<any> = [];
	constructor(
		private location: Location,
		private modalService: SuiModalService,
		private formBuilder: FormBuilderService
	) {}
	goBack() {
		this.location.back();
	}

	editField(event) {
		console.log(event);
		this.modalService
			.open(new FieldModal('Edit Field', event, this.fieldArrays, true, ModalSize.Tiny))
			.onApprove((eq: any[]) => {
				console.log(eq);
				this.fieldArrays = eq;
			})
			.onDeny(() => console.log('add certificate holder cancel'));
	}

	addField(event) {}

	// check for unique model name
	checkUnique(fieldname): Promise<any> {
		return new Promise((resolve, reject) => {
			let count = [];
			var arrayFlatten;
			arrayFlatten = function(arr) {
				for (let i = 0; i < arr.length; i++) {
					let items = arr[i];
					if (
						'group' in items &&
						typeof items['group'] !== 'undefined' &&
						items['group'] !== null &&
						items['group'].length > 0
					) {
						arrayFlatten(items['group']);
					} else if (items['name'] === fieldname) {
						count.push(items);
						// console.log(items)
					}
				}
			};
			arrayFlatten(this.fieldArrays);
			if (count.length > 0) {
				this.error = true;
				reject('false');
			} else {
				this.error = false;
				resolve('true');
			}
		});
	}

	checkEditUnique(fieldname): Promise<any> {
		return new Promise((resolve, reject) => {
			let count = [];
			var arrayFlatten;
			arrayFlatten = function(arr) {
				for (let i = 0; i < arr.length; i++) {
					let items = arr[i];
					if (
						'group' in items &&
						typeof items['group'] !== 'undefined' &&
						items['group'] !== null &&
						items['group'].length > 0
					) {
						arrayFlatten(items['group']);
					} else if (items['name'] === fieldname.name && items['id'] !== fieldname.id) {
						count.push(items);
						// console.log(items)
					}
				}
			};
			arrayFlatten(this.fieldArrays);
			if (count.length > 0) {
				this.error = true;
				reject('false');
			} else {
				this.error = false;
				resolve('true');
			}
		});
	}

	cloneField(fieldname) {
		let obj = this.fieldArrays;
		var arrayFlatten;
		arrayFlatten = function(arr) {
			for (let i = 0; i < arr.length; i++) {
				let items = arr[i];
				if (
					'group' in items &&
					typeof items['group'] !== 'undefined' &&
					items['group'] !== null &&
					items['group'].length > 0 &&
					fieldname.type !== 'group'
				) {
					arrayFlatten(items['group']);
				} else if (
					items['name'] === fieldname.name &&
					fieldname.type === 'group' &&
					items['group'].length > 0
				) {
					let relname = Math.random().toString(36).substr(2, 5);
					let oj = fieldname.name;
					let name = `${oj}_${relname}`;
					let newObj = JSON.parse(JSON.stringify(fieldname));
					newObj.id = name;
					newObj.name = name;
					let grp = newObj['group'];
					// loop through children and recreate id,name and parentModel properties value
					for (let x = 0; x < grp.length; x++) {
						let relname = Math.random().toString(36).substr(2, 5);
						let name = grp[x].name;
						grp[x].id = `${name}_${relname}`;
						grp[x].label = `${name}_${relname}`;
						grp[x].name = `${name}_${relname}`;
						grp[x].parentModel = `${newObj.id}`;
					}
					// console.log(newObj);
					let idx = i + 1;
					arr.splice(idx, 0, newObj);
					return arr;
				} else if (items['name'] === fieldname.name) {
					let relname = Math.random().toString(36).substr(2, 5);
					let oj = fieldname.name;
					let name = `${oj}_${relname}`;
					let newObj = JSON.parse(JSON.stringify(fieldname));
					newObj.id = name;
					newObj.label = name;
					newObj.name = name;
					// console.log(newObj);
					let idx = i + 1;
					arr.splice(idx, 0, newObj);
					return arr;
				}
			}
		};
		arrayFlatten(obj);
		// this.store.dispatch(new XlsFormActions.XlsFormFieldClonedAction(obj));
	}

	deleteField(xlsForm_Field) {
		let newarr = Object.assign(this.fieldArrays);
		var arrayFlatten;
		arrayFlatten = function(arr) {
			// console.log('havoc')
			for (let i = 0; i < arr.length; i++) {
				let items = arr[i];
				if (items['name'] === xlsForm_Field.name) {
					arr.splice(i, 1);
					// console.log(arr)
				} else if (
					'group' in items &&
					typeof items['group'] !== 'undefined' &&
					items['group'] !== null &&
					items['group'].length > 0 &&
					xlsForm_Field.type !== 'group'
				) {
					arrayFlatten(items['group']);
				}
			}
		};
		arrayFlatten(newarr);
		// console.log(newarr)
		// this.store.dispatch(new XlsFormActions.XlsFormFieldDeleteSuccessAction(newarr));
	}

	addToFormGroup(evnt) {
		this.modalService
			.open(new FieldSelectionModal('Component Type', null, ModalSize.Tiny))
			.onApprove((eq: any) => {
				let model = eq;
				let id = evnt.id;
				let relname = Math.random().toString(36).substr(2, 5);
				let name = model.name;
				model['id'] = `${id}_${name}_${relname}`;
				model['name'] = `${id}_${name}_${relname}`;
				model['type'] = model.type;
				model['control'] = model.control;
				model['parentModel'] = id;
				model['relevantGroup'] = { relComp: '', relOperator: '' };
				model['constraintGroup'] = { constOperator: '', constStatus: '' };
				model['hint'] = '';
				this.formBuilder.setChildGroup(Object.assign({}, { model: model, group: evnt.id }));
				this.modalService
					.open(new FieldModal('Edit Field', model, this.fieldArrays, false, ModalSize.Tiny))
					.onApprove((eq: any[]) => {
						// this.selectedCertificateHolder = eq;
						// this.startApplication(eq);
						console.log(eq);
						localStorage.setItem('builder', JSON.stringify(eq));
						this.fieldArrays = eq;
					})
					.onDeny(() => console.log('add certificate holder cancel'));
			})
			.onDeny(() => console.log('add certificate holder cancel'));
	}

	addSection() {
		this.newTemplate({
			label: 'Field Set',
			id: '',
			name: 'group',
			inputType: 'group',
			inputStyle: 'group',
			control: 'input',
			icon: 'fa fa-object-group',
			title: 'Group related fields'
		});
	}

	addDocument() {
		this.modalService
			.open(new FieldSelectionModal('Component Type', '', ModalSize.Tiny))
			.onApprove((eq) => {
				// this.selectedCertificateHolder = eq;
				this.newTemplate(eq);
			})
			.onDeny(() => console.log('add certificate holder cancel'));
	}

	save() {}

	newTemplate($event) {
		let newProduct = $event;
		let relname = Math.random().toString(36).substr(2, 5);
		newProduct.id = `${newProduct.name}_${relname}`;
		newProduct['relevantGroup'] = { relComp: '', relOperator: '' };
		newProduct['constraintGroup'] = { constOperator: '', constStatus: '' };
		newProduct['hint'] = '';
		this.modalService
			.open(new FieldModal('Edit Activity', newProduct, this.fieldArrays, false, ModalSize.Tiny))
			.onApprove((eq: any[]) => {
				// this.selectedCertificateHolder = eq;
				// this.startApplication(eq);
				console.log(eq);
				this.fieldArrays = eq;
			})
			.onDeny(() => console.log('add certificate holder cancel'));
	}
	ngOnInit(): void {}
}
